import { Card, CardBody } from "@progress/kendo-react-layout";
import { BuyerCard } from "./CatchDataCard";
import styles from "../../../styles.module.css";
import { COLOR } from "utils/constant";
import { t } from "i18next";

export function BuyerGuarantee({
	availableBalance,
	balance,
	availableBalancePercentage,
	isMobileView,
}: {
	availableBalance?: number;
	balance?: number;
	availableBalancePercentage?: number;
	isMobileView?: boolean;
}) {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: "30px",
			}}
		>
			<Card
				style={{
					flex: 1,
					// paddingLeft: "10px",
					// paddingRight: "10px",
					// paddingTop: "10px",
					borderRadius: "12px",
				}}
				className={"home-card-item"}
			>
				<CardBody className="border-radius">
					<div
						className={`${styles.BoxHeadingSmall}`}
						style={{ display: "flex", justifyContent: "space-between" }}
					>
						{t("My") +
							" " +
							t("Purchase").toLocaleLowerCase() +
							" " +
							t("Guarantee").toLocaleLowerCase()}
					</div>

					<BuyerCard
						availableBalance={availableBalance || 0}
						balance={balance || 0}
						sliderColor={COLOR.BlueLight}
						percentage={availableBalancePercentage || 0}
					/>
				</CardBody>
			</Card>
		</div>
	);
}
